import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

function CLoader({ show = false }) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={show}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
}

export default CLoader;
